<template>
  <div v-if="template">
    <span
      v-if="type === 'language'"
      v-tooltip="template.status"
      :class="getClassesBadgeFull"
    >
      {{ template.language }}
    </span>

    <span
      v-else-if="type === 'category'"
      class="badge-template outline-primary"
    >
      {{ getCategory }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'language',
    },
    template: {
      type: Object,
      default: {},
    },
  },
  computed: {
    getCategory() {
      switch (this.template.category.toUpperCase()) {
        case 'UTILITY':
          return this.$t('WHATSAPP_TEMPLATES.CATEGORY.UTILITY');
        case 'MARKETING':
          return this.$t('WHATSAPP_TEMPLATES.CATEGORY.MARKETING');
        case 'AUTHENTICATION':
          return this.$t('WHATSAPP_TEMPLATES.CATEGORY.AUTHENTICATION');
        default:
          return this.template.category;
      }
    },
    getClassesBadgeFull() {
      const { status } = this.template;

      let classes = 'badge-template ';

      switch (status.toLowerCase()) {
        case 'approved':
          classes += 'full-success ';
          break;
        case 'submitted':
        case 'pending':
          classes += 'full-warning ';
          break;
        case 'rejected':
          classes += 'full-danger ';
          break;
        case 'vacation':
          classes += 'full-vacation ';
          break;
        case 'leave':
          classes += 'full-leave ';
          break;
        case 'day_off':
          classes += 'full-day-off ';
          break;
        case 'lunch_time':
          classes += 'full-lunch_time ';
          break;
      }

      return classes;
    },
  },
};
</script>

<style lang="scss" scoped>
.badge-template {
  padding: 8px 15px;
  border-radius: var(--border-radius-full);
  color: var(--white);
  font-weight: var(--font-weight-black);
  font-size: var(--font-size-micro);

  &.full-success {
    background-color: var(--g-900);
  }

  &.full-warning {
    background-color: var(--y-500);
  }

  &.full-danger {
    background-color: var(--r-800);
  }

  &.full-vacation {
    background-color: var(--r-500);
  }

  &.full-leave {
    background-color: var(--b-800);
  }

  &.full-day-off {
    background-color: var(--v-500);
  }

  &.full-lunch_time {
    background-color: var(--o-500);
  }

  &.outline-primary {
    border: 1px solid black;
    color: black;
  }
}
</style>
